import React from 'react';
import './Principle.css';

const Principle = () => {
    const statsData = [
        {
            count: "10+",
            text: "Years Of Proven Industry Experience"
        },
        {
            count: "500+",
            text: "Clients Served Across Australia"
        },
        {
            count: "$100M+",
            text: "In Assets Managed"
        },
        {
            count: "98%",
            text: "Client Satisfaction Rate"
        }
    ];

    return (
        <div className="principle-section">
            <div className="principle-container">
                <h2 className="principle-title">
                    PFGS Was Founded On A Simple Principle
                </h2>

                <p className="principle-description">
                    To make accounting feel less transactional and more personal. <span style={{ fontWeight: 500, color: 'black' }}>Located in Lewisham</span>,
                    NSW, we offer practical, tailored solutions in <span style={{ fontWeight: 500, color: 'black' }}>Tax Compliance, Business Advisory,
                        and Superannuation</span> — designed to help individuals and businesses thrive.
                </p>

                <p className="principle-description">
                    We don't just crunch numbers — we build partnerships. We focus on what truly
                    matters to you, offering honest conversations, reliable support, and a proactive
                    approach that delivers measurable results. <span style={{ fontWeight: 500, color: 'black' }}>Your success, wealth, and peace of mind
                        are always our priority.</span>
                </p>

                <div className="stats-grid">
                    {statsData.map((stat, index) => (
                        <div key={index} className="stat-item">
                            <div className="stat-count">{stat.count}</div>
                            <div className="stat-text">{stat.text}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Principle;
